import { io } from 'socket.io-client';

const ccServerHost = process.env.REACT_APP_CC_SERVER_HOST

export const socket = io(`${ccServerHost}/`, {
    autoConnect: false,
    transports: ['websocket']
});